// removed by extract-text-webpack-plugin
module.exports = {"btn":"_23rx7JLaCbtb1tkR_nPdL0","success":"_26Z3Qbft3W205eq7pwNBPi","danger":"_3SUUZBs3By84P0Rb2JSEZN","rounded":"_3QQHCMlscwYTmJX_z4Te5y","rounded-orange":"_3esxlhh9MsNrn8voZqdGVc","light":"_2_ifRVoZ6S9Pa0rV_-lE06"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/ActionBtnIcon/style.css
// module id = 407
// module chunks = 39